/* userGroup/actions */
import { action } from "typesafe-actions";
import { UserGroup, UserGroupActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown
) => action(UserGroupActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: UserGroup) =>
  action(UserGroupActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(UserGroupActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: UserGroup | null) => unknown
) => action(UserGroupActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: UserGroup) =>
  action(UserGroupActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(UserGroupActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(UserGroupActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(UserGroupActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(UserGroupActionTypes.DELETE_ERROR, error);
